import { render, staticRenderFns } from "./setTestUser.vue?vue&type=template&id=1196363c&scoped=true&"
import script from "./setTestUser.vue?vue&type=script&lang=js&"
export * from "./setTestUser.vue?vue&type=script&lang=js&"
import style0 from "./setTestUser.vue?vue&type=style&index=0&id=1196363c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196363c",
  null
  
)

export default component.exports